module.exports = __webpack_public_path__ + "static/media/whatsapp-polos.77e7cf15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/whatsapp-polos.svg
// module id = 763
// module chunks = 0